import { Injectable } from '@angular/core';
import { LoaderService } from '@shared/services/loader.service';
import { UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { map, Observable, of } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class VatNumberAvailableAsyncValidator {
    constructor(
        private loaderService: LoaderService,
        private userServiceProxy: UserServiceProxy,
    ) {}

    validate(userId?: number): AsyncValidatorFn {
        return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
            this.loaderService.deactivate();
            const isWhiteString = !`${control.value}`.replace(/\s/g, '').length;
            if (!isWhiteString) {
                const vatNumber = control.value as string;
                return this.userServiceProxy.isVatNumberCorrect(vatNumber, userId).pipe(
                    map((allowed) => (allowed ? null : { vatNumberAlreadyExists: true })),
                    finalize(() => this.loaderService.activate()),
                );
            } else {
                return of(null);
            }
        };
    }
}
